import React from 'react';
import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Button from 'material-ui/Button';

class PageSubHeader extends React.Component {

    handleChange() {
        this.props.onUserInput(this.refs.filterTextInput.value ? this.refs.filterTextInput.value.toLowerCase() : undefined);
    }
    render() {
        const { teamDetails, placeholder } = this.props;
        // let _TeamList = <MenuItem key='0' value={0}
        //     style={{ fontWeight: '500' }}>
        //     {'Select Team'}
        // </MenuItem>

        let _SelectTeamList = <MenuItem key='0' value={0}
            style={{ fontWeight: '500' }}>
            {'Select Team'}
        </MenuItem>

        let _TeamList;

        // console.log('AddRole TeamList', roleList)
        const committeeList = teamDetails ? teamDetails.switchteamdetailsList : null;
        if (committeeList && committeeList.length > 0) {
            _TeamList = <MenuItem key='0' value={0}
                style={{ fontWeight: '500' }}>
                {'Select Team'}
            </MenuItem>
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }
        return (
            <Card className="mb-0">
                <CardHeader className="bg-white p-0">
                    <div className="row p-2">
                        <div className="col-3 pt-2 pl-4">
                            <div className={`search-bar right-side-icon bg-transparent`}>
                                {!this.props.hideSearch ? <div className="form-group">
                                    <input className="form-control border-1" type="search" placeholder="Search" onChange={this.handleChange.bind(this)}
                                        ref="filterTextInput" value={this.props.filterText} />
                                    <button className="search-icon"><i className="zmdi zmdi-search zmdi-hc-lg" /></button>
                                </div>
                                    : null}
                            </div>
                        </div>
                        <div className="col-3" />
                        <div className="col-2 text-right pt-3 ft14"> Team Name :</div>
                        <div className="col-4">
                            <FormControl className="w-100 mt-2 col-12">
                                <Select
                                    value={Number(this.props.committee_id ? this.props.committee_id : 0)}
                                    onChange={this.props.handleChangeTeam.bind(this)}
                                    input={<Input id="age-simple" />}
                                >
                                    {_SelectTeamList}
                                    {_TeamList}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </CardHeader>
            </Card>
        );
    }
}
export default PageSubHeader;


// WEBPACK FOOTER //
// ./app/pagesubheader.js